import { useEffect } from "react";
import ChildFilterErrors from "types/ChildFilterErrors";

interface useSetChildFilterErrorProps{
    param: string,
    name: string,
    isChildFilterEmpty: boolean
    parentFilterName: string | false,
    wasLoaded: boolean
    setChildFilterErrors: (callback: (prev: ChildFilterErrors) => ChildFilterErrors) => void;
}

const useSetChildFilterError = (props: useSetChildFilterErrorProps) => {
  useEffect(() => {

      props.setChildFilterErrors((prevErrors) => {
        if (props.wasLoaded && props.isChildFilterEmpty) {
          return {
            ...prevErrors,
            [props.param]: {
              filterName: props.name,
              parentFilterName: props.parentFilterName,
            },
          };
        } else {
          const { [props.param]: _, ...newErrors } = prevErrors; 
          return newErrors;
        }
      });
    }, [props.isChildFilterEmpty, props.wasLoaded]);
  }

export default useSetChildFilterError 